import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { App_Footer } from '../components/App_Footer_Retail';
import { App_Header } from '../components/App_Header_Retail';
import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { ViewProductDetailDataModal } from './Modal_ViewProductDetails';
import { DeleteInventoryProductModal } from './Modal_DeleteInventoryProduct';
import { Modal_StockProduct_Online } from './Modal_Inventory_StockProduct_Online';
import { Modal_StockProduct_InStore } from './Modal_Inventory_StockProduct_OnSite';

import { Preferences } from '@capacitor/preferences'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

 export function Tab_Management_ProductList () {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);

    let [addProductModal, setAddProductModal] = useState(false);
    let [modifyProductModal, setModifyProductModal] = useState(false);
    let [viewInventoryProductMainDetailsData_online, setViewInventoryProductMainDetailsData_online] = useState([]);
    let [viewInventoryProductMainDetailsData_onsite, setViewInventoryProductMainDetailsData_onsite] = useState([]);

    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);

    let [deleteInventoryProductModal, setDeleteInventoryProductModal] = useState(false);
    let [adminPasswordCreateInventoryProductModal, setAdminPasswordCreateInventoryProductModal] = useState(false);
    let [adminPasswordDeleteProductModal, setAdminPasswordDeleteProductModal] = useState(false);

    let [activateProductButton, setActivateProductButton] = useState('inline-block');
    let [deactivateProductButton, setDeactivateProductButton] = useState('inline-block');

    let [showProductPics, setShowProductPics] = useState(false);
    let [itemID, setItemID] = useState(null);
    let [productID, setProductID] = useState(null);
    let [productSalePrice, setProductSalePrice] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productPic1, setProductPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic2, setProductPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic3, setProductPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic4, setProductPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPicsModal, setProductPicsModal] = useState(false);

    let [discountOfList, setDiscountOfList] = useState(null);
    let [salePrice, setSalePrice] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);

    let [searchResults, setSearchResults] = useState([]);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [online_view, setOnline_view] = useState('outline')
    let [inStore_view, setIn_Store_view] = useState('clear')

    let [viewStockProductOnlineModal, setViewStockProductOnlineModal] = useState(false);
    let [viewStockProductInStoreModal, setViewStockProductInStoreModal] = useState(false);

    let slideRef = useRef(null);





    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        if(searchCategory === 'stock_product')
        {

            Tracker = '74302_stock_product';
        }
        else if(searchCategory === 'delete_stock_product')
        {

            Tracker = '74304_delete_stock_product';

        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '72302_search_inventory_items',
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_productId: cols[0],
                                        db_productName: cols[1],
                                        db_productDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorPhoneNumber: cols[4],
                                        db_vendorAddress: cols[5],
                                        db_vendorCity: cols[6],
                                        db_vendorCountry: cols[7],
                                        db_costPerUnit: cols[8],
                                        dv_salePrice: cols[9],
                                        db_pic1: cols[10],
                                        db_pic2: cols[11],
                                        db_pic3: cols[12],
                                        db_pic4: cols[13],
                                        db_attachement: cols[14],
                                        db_createdBy: cols[15],
                                        db_isActivated: cols[16],
                                        db_storefront: cols[17],
                                        db_qtyAvailable: cols[18],


                                    })
                                });

                            }

                    })
        }

    function getDataProductMain_online() {
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74301_productList_online',
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewInventoryProductMainDetailsData_online((prevViewInventoryProductMainDetailsData) => {
                    return prevViewInventoryProductMainDetailsData.concat({
                        productID: cols[0],
                        productType: cols[1],
                        productName: cols[2],
                        productPartNum: cols[3],
                        productPhoneNumber: cols[4],
                        productCostPerUnit: parseFloat(cols[5]).toFixed(2),
                        productSalePrice: parseFloat(cols[6]).toFixed(2),
                        productPic1: cols[7],
                        productPic2: cols[8],
                        productPic3: cols[9],
                        productPic4: cols[10],
                        productDateCreated: cols[11],
                        productAddedBy: cols[12],
                        productIsActivated: cols[13],
                    })
                });

            } 
        })
        
}

function getDataProductMain_onSite() {
            
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74301_productList_onSite',
            user: acctID,
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setViewInventoryProductMainDetailsData_onsite((prevViewInventoryProductMainDetailsData) => {
                return prevViewInventoryProductMainDetailsData.concat({
                    productID: cols[0],
                    productType: cols[1],
                    productName: cols[2],
                    productPartNum: cols[3],
                    productPhoneNumber: cols[4],
                    productCostPerUnit: parseFloat(cols[5]).toFixed(2),
                    productSalePrice: parseFloat(cols[6]).toFixed(2),
                    productPic1: cols[7],
                    productPic2: cols[8],
                    productPic3: cols[9],
                    productPic4: cols[10],
                    productDateCreated: cols[11],
                    productAddedBy: cols[12],
                    productIsActivated: cols[13],
                })
            });

        } 
    })
    
}


function activationStatus(event) {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74309_activation_product',
            user: acctID,
            xInventoryProductID: event[1],
            xProductActivationStatus: event[0],
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');
        let cols = rows[0].split('|');

        alert(cols[0]);


        if(authenticatedMerchent_context.initialSetup?.details?.step_4 == false && cols[1].trim() === 'PRODUCT_ACTIVATED')
        {
            updateInitialSetup({step_1: true, step_2: true, step_3: true, step_4: true});
            automaticOnboarding();
        }
        else
        {
            setViewInventoryProductMainDetailsData_online([]);
            setViewInventoryProductMainDetailsData_onsite([]);
            getDataProductMain_online(); 
            getDataProductMain_onSite();         
        }
    })

}


function updateInitialSetup(event) {



     let formData = new FormData();
     formData.append('Tracker', '74003B_update_initialSetup');
     formData.append('user', acctID);
     formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
     formData.append('xInitialSetup_details', JSON.stringify(event));
     formData.append('sessionID', sessionID);


     const requestOptions = {
         enctype: 'multipart/form-data',
         method: 'POST',
         credentials: 'include',
         headers: {
             'Accept': 'text/html, application/json',
             //'content-type': 'application/json',
          },
         file: formData,
         body: formData,
         contentType: false,
         processData: false,
         /*body: JSON.stringify({
             Tracker: '72001B',
             user: acctID,
         })*/
     }

     fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
     .then(res => res.text())
     .then(res => {


        let rows = res.toString().split('~~~');
        let lines3 = rows[0].split('|');
        
         setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);


         let initialSetupParsed = {};
                
         try {
         initialSetupParsed = JSON.stringify({
             setup_id: lines3[0],
             details: lines3[1],
             status: lines3[2],
             dateCreated: lines3[3],
             lastModified: lines3[4],
         })
             ? JSON.parse(JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })) : {};

         if (typeof initialSetupParsed.details === 'string') {
             initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
         }
         } catch (e) {
         console.warn('Error parsing initialSetup:', e);
         initialSetupParsed = {};
         }


      authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 
        
         
         //setShowProductPics(false);
         //setViewProductDetailsData([]);
         //ssetViewProductDetailsData([]);

         //handleRoute('/retail_merchantMainPageApp'); 

     })
 }


function automaticOnboarding() 
{
    let formData = new FormData();
    formData.append('Tracker', '74003B_update_automaticOnboarding');
    formData.append('user', acctID);
    formData.append('sessionID', sessionID);


    const requestOptions = {
        method:'POST',
        credentials: 'include',
        body: formData,
    }

    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);
        window.location.href = '/retail_merchantMainPageApp';
    })
    .catch(error => {
        console.error(error);
    })

}

function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}

function confirmProductModify() 
{
    let formData = new FormData();
    formData.append('Tracker', '72307_retail');
    formData.append('user', acctID);
    formData.append('xProductID', productID);
    formData.append('xProductDOL', discountOfList);
    formData.append('xSupportingDocumentation', selectedFile);


    const requestOptions = {
        method:'POST',
        credentials: 'include',
        body: formData,
    }

    fetch(baseURL+'merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);
    })
    .catch(error => {
        console.error(error);
    })

}

function saveUploadedFile(event) {
    
    alert(event);
    
    if(event.target.files == null)
    {
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")
    }
    else
    {
        setSelectedFile(event.target.files[0])

    }


}

let timeout;

function handleInput(event) {


    document.getElementById('searchInventoryProduct_StockProductItemsList').innerHTML = '';


    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

function productDetailsHandler(event)
{
    //alert("in product details handler");
    //alert(event[1]);


    setProductID(event[1]);
    setProductSalePrice(event[2]);
    setShowProductDetails(event[0]);
}

async function handleSlideChange()
{

    let swiper = await slideRef.current?.getSwiper();

    //let activeIndex = swiper?.activeIndex; // Get the current slide index

    let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

    //alert(realIndex);

    if (realIndex === 0) { // Example: Execute a function when reaching slide 3
        onlineHandler();
    }
    else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
        inStoreHandler();
    }
  };


const slideOpts = {
initialSlide: 0, // Start at the first slide
speed: 100, // Animation speed (in ms)
loop: false, // Enable looping
};

function onlineHandler()
{
    //setInventory_roomsTab_data(true);
    //setInventory_itemsTab_data(false);

    setOnline_view('outline');
    setIn_Store_view('clear');



}
function inStoreHandler()
{
    //setInventory_roomsTab_data(false);
    //setInventory_itemsTab_data(true);

    setOnline_view('clear');
    setIn_Store_view('outline');

}



useEffect(() =>  {
        
    getDataProductMain_online(); 

    getDataProductMain_onSite();   

}, [])


        return (

            <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol size='6'>
                            <IonButton className='tab_buttons' fill={online_view} onClick={() => slideRef.current?.slideTo(0, 100)}> <IonLabel>ONLINE</IonLabel> </IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton className='tab_buttons' fill={inStore_view} onClick={() => slideRef.current?.slideTo(1, 100)}> <IonLabel>IN-STORE</IonLabel> </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        {online_view == 'outline' && <IonCol>
                            <IonButton onClick={() => setViewStockProductOnlineModal(true)}>ReStock</IonButton>
                        </IonCol>}
                        {inStore_view == 'outline' && <IonCol className='ion-text-right'>
                            <IonButton onClick={() => setViewStockProductInStoreModal(true)}>ReStock</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setDeleteInventoryProductModal(true)}>DELETE</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
            <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} options={slideOpts}>
                    <IonSlide>

                                <IonGrid >
                                    <IonRow>
                                        <IonCol size='12'>
                                            <h3> Online Product List </h3>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow >
                                            {/*<IonCol size="3">ID</IonCol>*/}
                                            <IonCol size="4">Name</IonCol>
                                            <IonCol size="3">Price</IonCol>
                                            {/*<IonCol >Margin</IonCol>*/}
                                            <IonCol size="5">Action</IonCol>
                                    </IonRow>
                                    {viewInventoryProductMainDetailsData_online.map((detailData) =>   {
                                        return (
                                            <IonRow class='gridResultBody'>
                                                {/*IonCol size="3">{detailData.productID}</IonCol>*/}
                                                <IonCol size="4">{detailData.productName}</IonCol>
                                                <IonCol size="3">{detailData.productSalePrice}</IonCol>
                                                {/*<IonCol >{detailData.margin}</IonCol>*/}
                                                {detailData.productIsActivated == 'no' &&  
                                                    <IonCol size="5">
                                                        <IonButton className='small_button' onClick={() => productDetailsHandler([true, detailData.productID, detailData.productSalePrice])}>Details </IonButton>
                                                        {((authenticatedMerchent_context.initialSetup?.details?.step_4 == false || 
                                                        (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '5' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                                        )) ? <IonButton className='flash-tutorial small_button' id='productIsDeactivated' style={{display: activateProductButton}} onClick={() => activationStatus(["yes", detailData.productID])}> ACTIVATE </IonButton>
                                                            : <IonButton className='small_button' id='productIsDeactivated' style={{display: activateProductButton}} onClick={() => activationStatus(["yes", detailData.productID])}> ACTIVATE </IonButton>}
                                                    </IonCol>
                                                }

                                                {detailData.productIsActivated == 'yes' &&  
                                                    <IonCol size="5">
                                                        <IonButton className='small_button' onClick={() => productDetailsHandler([true, detailData.productID, detailData.productSalePrice])}>Details </IonButton>                                                
                                                        {( (authenticatedMerchent_context.initialSetup?.details?.step_4 == true && 
                                                        (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '5' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                                        ))  ? <IonButton className='flash-tutorial small_button' id='productIsActivated' style={{display: deactivateProductButton}} onClick={() => activationStatus(["no", detailData.productID])}> DEACTIVATE </IonButton>
                                                        : <IonButton className='small_button' id='productIsActivated' style={{display: deactivateProductButton}} onClick={() => activationStatus(["no", detailData.productID])}> DEACTIVATE </IonButton>}
                                                    </IonCol>
                                                }
                                            </IonRow>
                                        )
                                    }
                                    )}
                                </IonGrid>
                    </IonSlide>
                    <IonSlide>

                            <IonGrid >
                            <IonRow>
                                        <IonCol size='12'>
                                        <h3> On-Site Product List </h3>
                                        </IonCol>
                                    </IonRow>
                                <IonRow >
                                        {/*<IonCol size="1">ID</IonCol>*/}
                                        <IonCol size="4">Name</IonCol>
                                        <IonCol size="3">Price</IonCol>
                                        {/*<IonCol >Margin</IonCol>*/}
                                        <IonCol size="5">Action</IonCol>
                                </IonRow>
                                {viewInventoryProductMainDetailsData_onsite.map((detailData) =>   {
                                    return (
                                        <IonRow class='gridResultBody'>
                                        {/*IonCol size="3">{detailData.productID}</IonCol>*/}
                                        <IonCol size="4">{detailData.productName}</IonCol>
                                        <IonCol size="3">{detailData.productSalePrice}</IonCol>
                                        {/*<IonCol >{detailData.margin}</IonCol>*/}
                                        {detailData.productIsActivated == 'no' &&  
                                            <IonCol size="5">
                                                <IonButton className='small_button' onClick={() => productDetailsHandler([true, detailData.productID, detailData.productSalePrice])}>Details </IonButton>
                                                {((authenticatedMerchent_context.initialSetup?.details?.step_4 == false || 
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '5' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                                )) ? <IonButton className='flash-tutorial small_button' id='productIsDeactivated' style={{display: activateProductButton}} onClick={() => activationStatus(["yes", detailData.productID])}> ACTIVATE </IonButton>
                                                    : <IonButton className='small_button' id='productIsDeactivated' style={{display: activateProductButton}} onClick={() => activationStatus(["yes", detailData.productID])}> ACTIVATE </IonButton>}
                                            </IonCol>
                                        }

                                        {detailData.productIsActivated == 'yes' &&  
                                            <IonCol size="5">
                                                <IonButton className='small_button' onClick={() => productDetailsHandler([true, detailData.productID, detailData.productSalePrice])}>Details </IonButton>
                                                {( (authenticatedMerchent_context.initialSetup?.details?.step_4 == true && 
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '5' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                                ))  ? <IonButton className='flash-tutorial small_button' id='productIsActivated' style={{display: deactivateProductButton}} onClick={() => activationStatus(["no", detailData.productID])}> DEACTIVATE </IonButton>
                                                : <IonButton className='small_button' id='productIsActivated' style={{display: deactivateProductButton}} onClick={() => activationStatus(["no", detailData.productID])}> DEACTIVATE </IonButton>}
                                            </IonCol>
                                        }
                                    </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            
                    </IonSlide>
                </IonSlides>

                {productPicsModal == true &&  <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                        productPic1: productPic1, 
                        productPic2: productPic2, 
                        productPic3: productPic3, 
                        productPic4: productPic4, 
                        productID: productID, 
                        productSalePrice: productSalePrice
                        }}>
                    </ShowProductPicsModal>}

                

                    {showProductDetails == true &&  <ViewProductDetailDataModal openModal={ showProductDetails } closeModal={() => setShowProductDetails(false)} data={{
                        productID: productID, 
                        productSalePrice: productSalePrice
                        }}>
                    </ViewProductDetailDataModal>}

                    {viewStockProductOnlineModal == true &&  <Modal_StockProduct_Online openModal={ viewStockProductOnlineModal } closeModal={() => setViewStockProductOnlineModal(false)}></Modal_StockProduct_Online>}

                    {deleteInventoryProductModal == true &&  <DeleteInventoryProductModal openModal={ deleteInventoryProductModal } closeModal={() => setDeleteInventoryProductModal(false)}></DeleteInventoryProductModal>}

                    {viewStockProductInStoreModal == true &&  <Modal_StockProduct_InStore openModal={ viewStockProductInStoreModal } closeModal={() => setViewStockProductInStoreModal(false)}></Modal_StockProduct_InStore>}


            </IonContent>
            </React.Fragment>
        )
    }   



export default Tab_Management_ProductList;